import { gql } from '@apollo/client';

export const MONEY_OBJECT = gql`
    fragment MoneyObject on ABMoney {
        centAmount
        currencyCode
        fractionDigits
    }
`;
